module.exports = __webpack_public_path__ + "static/img/parkimg.fca0c556.png";